import React, { useEffect, useState } from "react";
import { callApi } from "../components/common/Apis";
import PlayList from "../components/template/playList";
import $ from "jquery";
import _ from "underscore";

import VideoScreen from "../components/template/VideoScreen";

import modelObj from "../utils/cookieUtils";

import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { BsArrowRepeat } from "react-icons/bs";
import { BiLoaderCircle } from "react-icons/bi";
import { RiLoader4Fill } from "react-icons/ri";
import { BsArrowsFullscreen } from "react-icons/bs";

import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate, useLocation } from "react-router";

import PulseLoader from 'react-spinners/PulseLoader';

import { intervalLogging, stopLogging } from "../components/common/logger";

export default function VideoList(props) {
    const navigate = useNavigate();
    const location = useLocation();

    var playList = null;

    var isEndList = false;
    var listSize = 50;

    let dataNum = null;

    const [dataKey, setDataKey] = useState();
    const [path, setPath] = useState(" ");
    const [frontTime, setFrontTime] = useState(2);
    const [duration, setDuration] = useState(7);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(null);
    const [initListLoading, setInitListLoading] = useState(true);
    const [listLoading, setListLoading] = useState(false);
    const [anotherPath, setAnotherPath] = useState();
    const [playing, setPlaying] = useState(null);
    const [icon, setIcon] = useState(faPause);
    const [captionState, setCaptionState] = useState(true);
    const [videoTypeArr,setVideoTypeArr] = useState([]);
    const [nonVideoTypeArr, setNonVideoTypeArr] = useState([]);

    const [currVideo, setCurrVideo] = useState(); // 현재 영상 유형

    const [timeoutCheck, setTimeoutCheck] = useState();

    //setPath 설정 여부를 결정하기 위해 사용할 gameID
    // var gameID = null;
    const [gameID, setGameID] = useState();

    const [criteria, setCriteria] = useState({
        ...props.criteria,
        beginIdx: 0,
        listSize: 50,
    });

    const [videoList, setVideoList] = useState({
        playList: [],
        videoInfos: [],
        useLang: null,
        cookie: modelObj,
    });

    useEffect(() => {
        props.setMenuTitle("클립 영상 목록");
        stopLogging();
        modelObj.renderLanguage();
        if (
            typeof criteria !== "undefined" &&
            criteria.gameInfoIds.length !== 0
        ) {
            setLoading(true);

            //스피너 배치 때문에 미리 영역의 높이 설정 필요
            adjustListSizeHandler();

            //playList에 넘겨줄 데이터 가져오기
            callApi("/hiball/tmp/game/gameRecordWithPitchTime", criteria, successHandler);

            //영상 src 및 선수 데이터 관련 정보 api 호출
            callApi("/hiball/tmp/code/clipsCommonInfos", criteria, detailSuccessHandler);
        }
        intervalLogging(location.pathname);
    }, []);

    /* useEffect(() => {
        modelObj.renderLanguage();
        if (
            typeof criteria !== "undefined" &&
            criteria.gameInfoIds.length !== 0
        ) {
            setLoading(true);

            //playList에 넘겨줄 데이터 가져오기
            callApi("/hiball/tmp/game/videoClips", criteria, successHandler);
        }
    }, [criteria.gameInfoIds]); */

    useEffect(() => {
        if (criteria.beginIdx > 0) {
            if (listLoading) {
                //로딩 O
                callApi(
                    "/hiball/tmp/game/gameRecordWithPitchTime",
                    criteria,
                    appendListHandler
                );
            }
        }
    }, [criteria.beginIdx]);

    useEffect(() => {
        if (typeof dataKey !== "undefined" && dataKey !== null) {
            highlightListHandler();
        }
    }, [dataKey]);

    useEffect(() => {
        //path가 바뀔때 스피너를 넣어주는 방법 이용
        if (!loading) {
            //태깅정보 없을땐 (path가 비어있을땐) 스피너 필요X
            if(path != " "){
                setLoading(true);
            }
        }
    }, [path]);

    useEffect(() => {
        settingCaptionOnOff();
    },[captionState]);

    const successHandler = (response) => {
        setLoading(false);
        setInitListLoading(false);

        var result = response.data;
        var gameVideoRecord = result.resultList;
        var records = 0;
        records = _.size(gameVideoRecord);

        if (records !== 0) {
            $("#clipListWrap").on("scroll", listScrollHandler);

            playList = gameVideoRecord;
            //Axios 통신 결과를 playList에 저장
            setVideoList((prevState) => ({
                ...prevState,
                playList: playList,
            }));

        } else {
            if (props.useLang === "en") {
                alert("Please check the video tagging information");
            } else {
                alert("영상 태깅 정보 확인이 필요합니다.");
            }
        }

        //영상 재생 방법 클릭 이벤트 핸들러 (repeat, sequence, justplay)
        $("[name='playingType']").on("click", selectPlayingTypeHandler);

        var playerScreen = document.getElementById("playerScreen");
        var video = playerScreen.getElementsByTagName("video");
        video[0].addEventListener("webkitendfullscreen", (evt) => {
            //모바일에서 화면을 닫아 영상이 멈췄을때 할 동작을 설정
            setPlaying(false);
            setIcon(faPause);
            $("#screenController").animate({ opacity: 0.5 }, 300);
            $("#playIcon").animate({ opacity: 0.8 }, 300);
        });

        document.addEventListener("fullscreenchange", (evt) => {
            if(document.fullscreenElement == null){
                //전체화면이 아닐 경우
                $("#videoTextDiv").css("height","30px");
                $("#videoTextArea").css("font-size","15px");
                $("#videoTextArea").css("padding","3px 0px");
            } else {
                //전체화면일 경우
                $("#videoTextDiv").css("height","60px");
                $("#videoTextArea").css("font-size","30px");
                $("#videoTextArea").css("padding","7px 0px");
            }
        });
    };

    const detailSuccessHandler = (response) => {
        var videoInfos = response.data.videoInfos;

        //경기 영상 src 및 videoType을 위한 데이터 저장
        setVideoList((prevState) => ({
            ...prevState,
            videoInfos: videoInfos,
        }));
    }

    const adjustListSizeHandler = () => {
        //영상 목록 높이 조절 이벤트 핸들러
        var height = window.innerHeight;

        if (height > 1200) {
            $("#videoClipList").height(window.innerHeight - 720);
        } else if (height >= 1024) {
            $("#videoClipList").height(window.innerHeight - 460);
        } else if (height >= 992) {
            $("#videoClipList").height(window.innerHeight - 120);
        } else if (height >= 800) {
            $("#videoClipList").height(window.innerHeight - 370);
        } else if (height >= 736) {
            $("#videoClipList").height(window.innerHeight - 390);
        } else if (height >= 640) {
            $("#videoClipList").height(window.innerHeight - 370);
        } else if (height >= 568) {
            $("#videoClipList").height(window.innerHeight - 320);
        } else {
            $("#videoClipList").height(window.innerHeight - 120);
        }
    };

    //영상 목록에서 경기 선택 이벤트 핸들러
    const selectClipEventHandler = (evt) => {
        stopLogging();
        intervalLogging(location.pathname);

        if(timeoutCheck){
            clearTimeout(timeoutCheck);
        }
        const checkValue = setTimeout(() => {
            //화면을 클릭했을 때 살짝 어두워지는 효과
            $("#screenController").animate({opacity:0.5}, 300);
            $('#playIcon').animate({opacity:0.8}, 300);

            setPlaying(false);
            setIcon(faPause);
        }, 300000);

        setTimeoutCheck(checkValue);

        var target = $(evt.currentTarget);
        var selectedPitch = target.attr("rel");
        var gameInfoId = selectedPitch.substring(0,6);
        var findPitch = "";
        var findVideo = "";
        var playingType = getPlayingType();
        var videoArr = [];
        var infoArr = [];
        var videoType = getVideoType();

        videoList.videoInfos.map((item, index) => {
            if(item.gameInfoId == gameInfoId){
                videoArr.push(item.cVideoType);
            }
        });

        videoArr = videoArr.sort();

        setVideoTypeArr(videoArr);

        //'전체' 선택 후 영상 자막이 꺼지는 구간에서 다른 영상을 클릭했을 경우를 위해 설정
        if(playingType == 'justplay'){
            setCaptionState(true);
        }

        if (dataNum != selectedPitch) {
            //만약 선택한 영상이 재생중인 영상과 다르면

            findPitch = videoList.playList.find(function (pitch) {
                var currentKey =
                    pitch.gameInfoId +
                    "" +
                    pitch.inning +
                    "" +
                    pitch.inningTb +
                    "" +
                    pitch.batInningTurn +
                    "" +
                    pitch.batPitchSeq;
                return currentKey === selectedPitch;
            });

            // 영상 최초 선택 시 영상 타입이 비어있을 경우 배열의 가장 첫번째 채워주기 (broadCast)
            if(videoType === ""){
                videoType = videoArr[0];
            }
            
            let pitchingTime = "";

            if(dataKey == undefined || dataKey == null){
                //처음으로 영상(클립) 선택 시
                findVideo = videoList.videoInfos.find(function (pitch) {
                    var currentKey = pitch.gameInfoId;
                    //경기ID가 같고 디폴트 영상유형이 같은 항목 리턴              
                    return (currentKey === gameInfoId) && (videoArr[0] == pitch.cVideoType);
                });

                pitchingTime = settingPitchingTime(findPitch, videoType);

                videoList.videoInfos.map((item, index) => {
                    videoArr.map((videoType, idx) => {
                        if ((item.gameInfoId === gameInfoId) && (videoArr[idx] == item.cVideoType)){
                            if(pitchingTime < 0){
                                infoArr.push(videoType);
                            }
                        }
                    });
                });

            } else {
                //첫번째로 선택한 영상(클립)이 아닐 경우
                if(gameInfoId != dataKey.substring(0,6)){
                    //라디오 버튼 변경을 위해서 일단 (1)전체 해제 후 (2)원하는 버튼 선택으로 설정
                    $("[name='videoTypeGroup']").removeClass("active");
                    $("[name='videoTypeGroup'][value='"+videoArr[0]+"']").addClass("active");

                    // 다른 경기 선택 시 영상 유형(broadcast, cam1..)이 바뀔 경우 바뀐 후 값으로 설정
                    videoType = videoArr[0];
                    pitchingTime = settingPitchingTime(findPitch, videoType);

                    //다른 경기 영상 선택했을 때
                    findVideo = videoList.videoInfos.find(function (pitch) {
                        var currentKey = pitch.gameInfoId;
                        //경기ID가 같고 디폴트 영상유형이 같은 항목 리턴              
                        return (currentKey === gameInfoId) && (videoArr[0] == pitch.cVideoType);
                    });

                    videoList.videoInfos.map((item, index) => {
                        videoArr.map((videoType, idx) => {
                            if ((item.gameInfoId === gameInfoId) && (videoArr[idx] == item.cVideoType)){
                                if(pitchingTime < 0){
                                    infoArr.push(videoType);
                                }
                            }
                        });
                    });
                    
                } else {
                    //같은 경기 영상 선택했을 때
                    pitchingTime = settingPitchingTime(findPitch, videoType);

                    videoList.videoInfos.map((item, index) => {
                        videoArr.map((videoType, idx) => {
                            if ((item.gameInfoId === gameInfoId) && (videoArr[idx] == item.cVideoType)){
                                if(pitchingTime < 0){
                                    infoArr.push(videoType);
                                }
                            }
                        });
                    });

                    findVideo = videoList.videoInfos.find(function (pitch) {
                        var currentKey = pitch.gameInfoId;
                        //경기ID가 같고 영상유형이 같은 항목 리턴     
                        if(infoArr.includes(videoType)){
                            //만약 기존에 선택되어 있던 값이 태깅 정보가 없는 영상유형일 경우
                        } else {
                            return (currentKey === gameInfoId) && (videoType == pitch.cVideoType);
                        }        
                    });
                }
            }

            setNonVideoTypeArr(infoArr);

            //선택한 클립 하이라이트 효과를 위한 dataKey 설정
            dataNum = selectedPitch;
            setDataKey(selectedPitch);

            //영상이 일시정지 된 상태로 다른 영상을 클릭했을 때 화면 어두운 효과 제거
            $("#playIcon").animate({ opacity: 0 }, 300);
            $("#screenController").animate({ opacity: 0 }, 300);

            if(findVideo == undefined){
                // alert("해당 투구에 대한 " + videoType + " 태깅 정보가 존재하지 않습니다.");
                $("#videoTextArea").html("해당 투구에 대한 " + videoType + " 태깅 정보가 존재하지 않습니다.");
                setPath(" ");
                $("#screenController").css("pointer-events","none");
            } else {
                
                if(path == " "){
                    //만약 이전에 상태가 '태깅정보 없음'이었다면 다시 화면 클릭 이벤트 핸들러 켜주기
                    $("#screenController").css("pointer-events","");
                }

                //리턴받은 findPitch에서 path(src) 값 추출
                var selectedVideoPath = findVideo.videoPath;
                var selectedGoogleVideoPath = findVideo.googleVideoPath;
                var startTime = pitchingTime;

                var g_ID = findVideo.gameInfoId;

                var mp4VideoPath = selectedVideoPath.replace(
                    "/mp4hls/index.m3u8",
                    " "
                );

                //다른 경기이거나 path 값이 비어있을때 (이전 선택 클립이 태깅정보가 없을 경우)
                if (gameID != g_ID || path == " ") {
                    // gameID = g_ID;
                    setGameID(g_ID);

                    // VideoScreen으로 넘겨줄 src 값을 set 해준다.
                    setPath(selectedGoogleVideoPath);
                    setAnotherPath(mp4VideoPath);
                }

                settingClipPlay(startTime, findPitch);

            }

        } else {
            //선택한 영상이 재생중인 영상과 같으면
        }

    };

    const getVideoType = () => {
		var videoType = '';
		var types = $("[name='videoTypeGroup']");
		_.each(types, function (type){
			if ($(type).hasClass('active')) {
				videoType = $(type).val();
			}
		});
		
		return videoType;

	}

    const settingClipPlay = (startTime, pitchInfo) => {
        //영상의 시작시간(frontTime)과 재생시간(duration) 설정
        var checkBase = pitchInfo.checkBase;
        var hitResultCode = pitchInfo.hitResultCode;
        var beforeOutCount = pitchInfo.beforeOutCount;
        var beforeRunnerState = pitchInfo.beforeRunnerState;
        var outCount = pitchInfo.outCount;

        //switch도 동일한 방법으로 값을 가져올 수 있음
        var forStaff = $("#forStaff").is(":checked");

        // Default frontTime = 2 & duration = 7
        var f_Time = 2;
        //var d_Time = 7;
        setDuration(7);

        if (
            typeof checkBase != "undefined" &&
            (checkBase != "0" || checkBase != 0)
        ) {
            //견제
            f_Time = 5;
            //d_Time = 10;
            setDuration(10);
        }

        if (
            typeof hitResultCode != "undefined" &&
            (hitResultCode != "0" || hitResultCode != 0)
        ) {
            // 타격 결과가 있는 경우 frontTime = 2 & duration = 10
            f_Time = 2;
            //d_Time = 10;
            setDuration(10);
            if (beforeOutCount != outCount) {
                //타격 결과가 있고 아웃카운트에 변동이 있을 경우 frontTime = 2 & duration = 17
                //d_Time = 17;
                setDuration(17);
            }
        }

        if (
            forStaff &&
            (beforeRunnerState != 0 || beforeRunnerState != "0")
        ) {
            // 코치용 재생시간 설정
            f_Time = 7;
            //d_Time = 17;
            setDuration(17);
        }

        var currentPlayingTime = startTime - f_Time;
        setFrontTime(currentPlayingTime);

        //자막 출력 여부 결정
        settingCaptionOnOff();

        //자막 텍스트 생성
        var videoText = trackTextMake(pitchInfo);
        $("#videoTextArea").html(videoText);
    };

    const trackTextMake = (info) => {
        //자막 생성하는 함수
        var checkBase = info.checkBase;
        var gameDay = getGameDay(info);
        var inning = info.inning;
        var inningTb = getInningTb(info);
        var batterName = getBatterName(info);
        var pitcherName = getPitcherName(info);
        var beforeStrikeCount = info.beforeStrikeCount;
        var beforeOutCount = info.beforeOutCount;
        var beforeBallCount = info.beforeBallCount;
        var ballCodeName = getBallCodeName(info);
        var ballSpeed = info.ballSpeed == null ? "0" : info.ballSpeed;
        var hitResultName = getHitResult(info);
        var beforeRunnerState = getRunnerState(info);
        var checkBaseState = getCheckBaseState(info);
        var result = "";
        if (checkBase < 1) {
            result =
                "[" +
                gameDay +
                "]  " +
                inning +
                inningTb +
                " " +
                batterName +
                " vs " +
                pitcherName +
                " " +
                beforeBallCount +
                "B-" +
                beforeStrikeCount +
                "S" +
                " " +
                beforeOutCount +
                "OUT" +
                " " +
                ballCodeName +
                ", " +
                ballSpeed +
                "km" +
                " " +
                hitResultName +
                ", " +
                beforeRunnerState;
        } else {
            result =
                "[" +
                gameDay +
                "]  " +
                +inning +
                inningTb +
                " " +
                batterName +
                " vs " +
                pitcherName +
                " " +
                beforeBallCount +
                "B-" +
                beforeStrikeCount +
                "S" +
                " " +
                beforeRunnerState +
                ", " +
                checkBaseState;
        }

        return result;
    };

    const getGameDay = (item) => {
        var gameDay = item.gameDay;
        var arr = gameDay.split('-');
        var gameDayFormat = arr[0].substr(-2) + "/" + arr[1] + "/" + arr[2];
        return gameDayFormat;
    }

    const getInningTb = (item) => {
        if (item.inningTb == "0") {
            if (props.useLang == "en") {
                return "T";
            } else {
                return "초";
            }
        } else {
            if (props.useLang == "en") {
                return "B";
            } else {
                return "말";
            }
        }
    };

    const getBatterName = (item) => {
        if (props.useLang == "en") {
            //영어일 경우
            if (item.batterForeignerYn == "Y") {
                return item.batterLastName;
            } else {
                return item.batterLastName + " " + item.batterShortName;
            }
        } else {
            //한국어일 경우
            return item.batterName;
        }
    };

    const getPitcherName = (item) => {
        if (props.useLang == "en") {
            //영어일 경우
            if (item.pitcherForeignerYn == "Y") {
                return item.pitcherLastName;
            } else {
                return (
                    item.pitcherLastName + " " + item.pitcherShortName
                );
            }
        } else {
            //한국어일 경우
            return item.pitcherName;
        }
    };

    const getBallCodeName = (item) => {
        if (props.useLang == "en") {
            return item.ballTypeShortName;
        } else {
            return item.ballCodeName;
        }
    };

    const getHitResult = (item) => {
        if (props.useLang == "en") {
            return item.hitResultShortName;
        } else {
            return item.hitResultName;
        }
    };

    const getRunnerState = (item) => {
        if (props.useLang == "en") {
            if (item.beforeRunnerState == 0) {
                return "NoBase";
            } else if (item.beforeRunnerState == 1) {
                return "1B";
            } else if (item.beforeRunnerState == 2) {
                return "2B";
            } else if (item.beforeRunnerState == 3) {
                return "1B,2B";
            } else if (item.beforeRunnerState == 4) {
                return "3B";
            } else if (item.beforeRunnerState == 5) {
                return "1B,3B";
            } else if (item.beforeRunnerState == 6) {
                return "2B,3B";
            } else {
                return "FullBase";
            }
        } else {
            if (item.beforeRunnerState == 0) {
                return "주자없음";
            } else if (item.beforeRunnerState == 1) {
                return "주자1루";
            } else if (item.beforeRunnerState == 2) {
                return "주자2루";
            } else if (item.beforeRunnerState == 3) {
                return "주자1,2루";
            } else if (item.beforeRunnerState == 4) {
                return "주자3루";
            } else if (item.beforeRunnerState == 5) {
                return "주자1,3루";
            } else if (item.beforeRunnerState == 6) {
                return "주자2,3루";
            } else {
                return "주자만루";
            }
        }
    };

    const getCheckBaseState = (item) => {
        if (item.checkBase == "1") {
            return videoList.cookie.getLanguage(props.useLang, "pick1st");
        } else if (item.checkBase == "2") {
            return videoList.cookie.getLanguage(props.useLang, "pick2nd");
        } else if (item.checkBase == "3") {
            return videoList.cookie.getLanguage(props.useLang, "pick3rd");
        } else if (item.checkBase == "23") {
            return videoList.cookie.getLanguage(
                props.useLang,
                "catcherPick1st"
            );
        } else if (item.checkBase == "24") {
            return videoList.cookie.getLanguage(
                props.useLang,
                "catcherPick2nd"
            );
        } else if (item.checkBase == "25") {
            return videoList.cookie.getLanguage(
                props.useLang,
                "catcherPick3rd"
            );
        }
    };

    const highlightListHandler = () => {
        var nextKey = dataKey;
        var height = 0;
        var list = $("[name='videoClips']");
        list.removeClass("active");

        for (var i = 0; i < list.length; i++) {
            var elem = list[i];
            var key = $(elem).attr("rel");

            if (key === nextKey) {
                $(elem).addClass("active");
                $("#clipListWrap").animate({ scrollTop: height }, 400);
                break;
            }

            //height += $(elem)[0].clientHeight;
            height += $(elem)[0].getBoundingClientRect().height;
        }
    };

    const settingCaptionOnOff = () => {
        var caption = $("#caption").is(":checked");
        var playingType = getPlayingType();

        if(caption == true){
            //자막 on
            if(playingType == 'justplay'){
                if(captionState == true){
                    $("#videoTextArea").animate({ opacity: 1 }, 10);
                    $("#videoTextDiv").animate({ opacity: 1 }, 10);
                } else if (captionState == false) {
                    $("#videoTextArea").animate({ opacity: 0 }, 10);
                    $("#videoTextDiv").animate({ opacity: 0 }, 10);
                }
            } else {
                $("#videoTextArea").animate({ opacity: 1 }, 10);
                $("#videoTextDiv").animate({ opacity: 1 }, 10);
            }
        } else {
            //자막 off
            $("#videoTextArea").animate({ opacity: 0 }, 10);
            $("#videoTextDiv").animate({ opacity: 0 }, 10);
        }
    }

    const getPlayingType = () => {
		var playingType = '';
		var types = $("[name='playingType']");
		_.each(types, function (type){
			if ($(type).hasClass('active')) {
				playingType = $(type).val();
			}
		});
		
		return playingType;

	}

    const selectPlayingTypeHandler = (evt) => {
        //영상 재생 방법 클릭 이벤트 핸들러
        $("[name='playingType']").removeClass("active");
        $(evt.currentTarget).addClass("active");
    };

    const listScrollHandler = (e) => {
        //영상 목록 스크롤 이벤트 핸들러
        var currentScrollTop = $("#clipListWrap").scrollTop(); //스크롤바의 상단위치
        var scrollH = $("#clipListWrap").height(); //스크롤바를 갖는 div의 높이
        var contentH = $("#clipContents").height(); //문서 전체 내용을 갖는 div의 높이

        if (!isEndList && currentScrollTop + scrollH + 1 >= contentH) {
            $("#clipListWrap").off("scroll", listScrollHandler);

            setListLoading(true);

            var num = page + 1;
            setPage(num);

            var beginIdx = num * listSize;

            setCriteria((prevState) => ({
                ...prevState,
                beginIdx: beginIdx,
            }));
        }
    };

    const appendListHandler = (result) => {
        //영상 목록에서 스크롤을 내렸을 때 목록이 추가되도록 해주는 이벤트 핸들러
        var res = result.data.resultList;
        var retrievedSize = res.length;

        if (retrievedSize < listSize) {
            isEndList = true;
        }

        if (videoList.playList != null) {
            playList = videoList.playList.concat(res);

            setVideoList((prevState) => ({
                ...prevState,
                playList: playList,
            }));

            setListLoading(false);

        } else {
            playList = res;
        }

        $("#clipListWrap").on("scroll", listScrollHandler);
    };

    const fullScreenEventHandler = () => {
        //전체화면 버튼 클릭 이벤트
        var playerScreen = document.getElementById("playerScreen");
        var video = playerScreen.getElementsByTagName("video");

        //영상 선택 여부 확인
        if ($(video[0]).attr("src") === " ") {
            if (props.useLang === "en") {
                alert("Please select a video first");
            } else {
                alert("재생할 영상을 선택해주세요");
            }
        } else {
            if (props.isMobile) {
                //모바일 화면일 경우
                video[0].webkitEnterFullScreen();
            } else {
                //브라우저일 경우
                playerScreen.requestFullscreen();
            }
        }
    };

    const changeVideoTypeHandler = (evt) => {
        $("[name='videoTypeGroup']").removeClass("active");
        $(evt.currentTarget).addClass("active");

        //영상이 일시정지 된 상태로 다른 영상을 클릭했을 때 화면 어두운 효과 제거하기 위함
        $("#playIcon").animate({ opacity: 0 }, 300);
        $("#screenController").animate({ opacity: 0 }, 300);

        if(path == " "){
            //만약 이전에 상태가 '태깅정보 없음'이었다면 다시 화면 클릭 이벤트 핸들러 켜주기
            $("#screenController").css("pointer-events","");
        }
        
        var videoType = getVideoType();
        var gameInfoId = dataKey.substring(0,6);
        var findPitch = "";
        var findVideo = "";

        findPitch = videoList.playList.find(function (pitch) {
            var currentKey =
                pitch.gameInfoId +
                "" +
                pitch.inning +
                "" +
                pitch.inningTb +
                "" +
                pitch.batInningTurn +
                "" +
                pitch.batPitchSeq;
            return currentKey === dataKey;
        });

        //playList에서 내가 선택한 경기의 rel 값에서 gameInfoId와 동일한것 찾기
        findVideo = videoList.videoInfos.find(function (pitch) {
            var currentKey = pitch.gameInfoId;
            //경기ID가 같고 영상유형이 같은 항목 리턴              
            return (currentKey === gameInfoId) && (videoType == pitch.cVideoType);
        });

        const pitchingTime = settingPitchingTime(findPitch, videoType);

        //리턴받은 findPitch에서 path(src) 값 추출
        var selectedVideoPath = findVideo.videoPath;
        var selectedGoogleVideoPath = findVideo.googleVideoPath;
        var startTime = pitchingTime;

        // var g_ID = findVideo.gameInfoId;

        var mp4VideoPath = selectedVideoPath.replace(
            "/mp4hls/index.m3u8",
            " "
        );

        // VideoScreen으로 넘겨줄 src 값을 set 해준다.
        setPath(selectedGoogleVideoPath);
        setAnotherPath(mp4VideoPath);

        settingClipPlay(startTime, findPitch);

    }

    // PitchTimes를 사용하기 위한 함수
    const settingPitchingTime = (findPitch, videoType) => {
        const timeArr = JSON.parse(findPitch.pitchTimes);
        var pitchingTime = 0;

        timeArr.map((item, idx) => {
            if(Object.keys(item) == videoType){
                pitchingTime = Object.values(item)[0];
            }
        });

        return pitchingTime;
    }

    return (
        <div className="container-fluid">
            <div
                id="videoWrapper"
                className="row video_wrap"
                style={{ margin: "1px", padding: "0px", width: "100%" }}
            >
                <div
                    className="col-12 col-sm-7 col-md-12 col-lg-8 col-xl-8 screen_wrap"
                    style={{ padding: "0px" }}
                >
                    <table
                        className="screen-controller-tb"
                        style={{ width: "100%" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="btn-group" style={props.isMobile ? {marginBottom:"5px", overflowY: "scroll", maxWidth: 330} : {marginBottom:"5px"}}>
                                        {videoTypeArr?.length != 0 ? videoTypeArr.map((item, index) => (
                                            <Button
                                                variant="outline-secondary"
                                                key={item}
                                                label={item}
                                                name="videoTypeGroup"
                                                type="radio"
                                                className={index == 0 ? "active" : null}
                                                value={item}
                                                style={props.isMobile ? {display:"flex", alignItems:"center", float:"left", fontSize: "11px"} : {display:"flex", alignItems:"center", float:"left"}}
                                                // defaultChecked={index == 0 ? true : false}
                                                onClick={changeVideoTypeHandler}
                                                disabled={nonVideoTypeArr.includes(item) ? true : false}
                                            >
                                                <span>{item}</span>
                                            </Button>
                                        )) : null}
                                    </div> 
                                </td>
                            </tr>
                            <tr>
                                <td
                                    id="playerScreen"
                                    className="video_player"
                                    style={{
                                        verticalAlign: "top",
                                        padding: "0px",
                                    }}
                                >
                                    <VideoScreen
                                        path={path}
                                        frontTime={frontTime}
                                        setFrontTime={setFrontTime}
                                        duration={duration}
                                        setDuration={setDuration}
                                        dataKey={dataKey}
                                        setDataKey={setDataKey}
                                        playList={videoList.playList}
                                        videoInfos={videoList.videoInfos}
                                        setPath={setPath}
                                        settingClipPlay={settingClipPlay}
                                        loading={loading}
                                        setLoading={setLoading}
                                        anotherPath={anotherPath}
                                        setAnotherPath={setAnotherPath}
                                        useLang={props.useLang}
                                        playing={playing}
                                        setPlaying={setPlaying}
                                        icon={icon}
                                        setIcon={setIcon}
                                        trackTextMake={trackTextMake}
                                        getPlayingType={getPlayingType}
                                        setCaptionState={setCaptionState}
                                        getVideoType={getVideoType}
                                        setVideoTypeArr={setVideoTypeArr}
                                        setNonVideoTypeArr={setNonVideoTypeArr}
                                        settingPitchingTime={settingPitchingTime}
                                        pathname={location.pathname}
                                        timeoutCheck={timeoutCheck}
                                        setTimeoutCheck={setTimeoutCheck}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    className="col-12 col-sm-5 col-md-12 col-lg-4 col-xl-4 list_wrap"
                    style={{ padding: "0px" }}
                >
                    <table style={{ marginLeft: "5px" }}>
                        <tbody>
                            <tr>
                                <td id="listFilter" className="list-controller">
                                    <table style={{ width: "100%" }}>
                                        <tbody>
                                            <tr>
                                                {/* <td width="10%" style="padding-left:3px;">
													<button id="openCriteria" className="btn btn-default btn-criteria"></button>
												</td> */}
                                                <td>
                                                    <table
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    style={{
                                                                        float: "left",
                                                                        padding:
                                                                            "2px",
                                                                        marginTop:
                                                                            "3px",
                                                                    }}
                                                                >
                                                                    <div
                                                                        id="switchArea"
                                                                        style={{
                                                                            display:
                                                                                "inline-block",
                                                                            margin: "3px",
                                                                            fontSize:
                                                                                "90%",
                                                                        }}
                                                                    >
                                                                        <Form.Check
                                                                            type="switch"
                                                                            id="forStaff"
                                                                            label={
                                                                                props.useLang ===
                                                                                "en"
                                                                                    ? "For Staff"
                                                                                    : "코치용"
                                                                            }
                                                                            style={{ float:"left" }}
                                                                        />
                                                                        <Form.Check
                                                                            type="switch"
                                                                            id="caption"
                                                                            label={
                                                                                props.useLang ===
                                                                                "en"
                                                                                    ? "Caption"
                                                                                    : "자막"
                                                                            }
                                                                            style={{ float:"left", marginLeft:"10px" }}
                                                                            defaultChecked={true}
                                                                            onChange={settingCaptionOnOff}
                                                                        />
                                                                    </div>
                                                                </td>

                                                                <td
                                                                    style={{
                                                                        float: "right",
                                                                    }}
                                                                >
                                                                    <div
                                                                        id="playingTypeBtnArea"
                                                                        className="btn-group"
                                                                        style={{
                                                                            float: "left",
                                                                            marginLeft:
                                                                                "10px",
                                                                            height: "43px",
                                                                        }}
                                                                    >
                                                                        <Button
                                                                            variant="outline-secondary"
                                                                            name="playingType"
                                                                            value="repeat"
                                                                            type="button"
                                                                            className="btn btn-default active"
                                                                            style={{
                                                                                fontSize:
                                                                                    "10px",
                                                                            }}
                                                                        >
                                                                            {/* <BsArrowRepeat style={{fontSize:"18px"}}></BsArrowRepeat> */}
                                                                            <span className="repeat-img"></span>
                                                                            <br />
                                                                            <span data-lang="repeat">반복</span>
                                                                        </Button>
                                                                        <Button
                                                                            variant="outline-secondary"
                                                                            name="playingType"
                                                                            value="sequence"
                                                                            type="button"
                                                                            className="btn btn-default"
                                                                            style={{
                                                                                fontSize:
                                                                                    "10px",
                                                                            }}
                                                                        >
                                                                            {/* <BiLoaderCircle style={{fontSize:"18px"}}></BiLoaderCircle> */}
                                                                            <span className="sequence-img"></span>
                                                                            <br />
                                                                            <span data-lang="sequence">순차</span>
                                                                        </Button>
                                                                        <Button
                                                                            variant="outline-secondary"
                                                                            name="playingType"
                                                                            value="justplay"
                                                                            type="button"
                                                                            className="btn btn-default"
                                                                            style={{
                                                                                fontSize:
                                                                                    "10px",
                                                                            }}
                                                                        >
                                                                            {/* <RiLoader4Fill style={{fontSize:"18px"}}></RiLoader4Fill> */}
                                                                            <span className="justplay-img"></span>
                                                                            <br />
                                                                            <span data-lang="justplay">전체</span>
                                                                        </Button>
                                                                    </div>
                                                                </td>

                                                                <td
                                                                    style={{
                                                                        float: "right",
                                                                    }}
                                                                >
                                                                    <Button
                                                                        id="fullScreenBtn"
                                                                        variant="outline-secondary"
                                                                        value="fullScreen"
                                                                        type="button"
                                                                        onClick={
                                                                            fullScreenEventHandler
                                                                        }
                                                                        style={{
                                                                            height: "43px",
                                                                        }}
                                                                    >
                                                                        {/* {props.useLang === 'en' ? "Full Screen" : "전체화면"} */}
                                                                        <BsArrowsFullscreen
                                                                            style={{
                                                                                display:
                                                                                    "flex",
                                                                            }}
                                                                        ></BsArrowsFullscreen>
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td id="clipList">
                                    <div style={{position:"relative", display:"flex", justifyContent:"center", alignItems:"center"}}>
                                        <Table
                                            className="player-list"
                                            style={{
                                                tableLayout: "fixed",
                                                width: "100%",
                                            }}
                                        >
                                            <tbody>
                                                <tr>
                                                    <td
                                                        id="videoClipTitle"
                                                        style={{
                                                            height: "auto",
                                                            padding: "0px",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                overflowY: "scroll",
                                                                height: "100%",
                                                                width: "100%",
                                                                border: "0px solid #e3e3e3",
                                                            }}
                                                        >
                                                            <table
                                                                id="videoTitleTable"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    textAlign:
                                                                        "center",
                                                                    overflow:
                                                                        "hidden",
                                                                    whiteSpace:
                                                                        "nowrap",
                                                                }}
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <th
                                                                            className="title"
                                                                            width="15%"
                                                                            data-lang="pitch"
                                                                        >
                                                                            투구
                                                                        </th>
                                                                        <th
                                                                            className="title"
                                                                            width="15%"
                                                                        >
                                                                            B-S
                                                                        </th>
                                                                        <th
                                                                            className="title"
                                                                            width="20%"
                                                                            data-lang="pitchType"
                                                                        >
                                                                            구종
                                                                        </th>
                                                                        <th
                                                                            className="title"
                                                                            width="20%"
                                                                            data-lang="pitchSpeed"
                                                                        >
                                                                            구속
                                                                        </th>
                                                                        <th
                                                                            className="title"
                                                                            width="15%"
                                                                            data-lang="result"
                                                                        >
                                                                            결과
                                                                        </th>
                                                                        <th
                                                                            className="title"
                                                                            width="15%"
                                                                            data-lang="pickOffs"
                                                                        >
                                                                            견제
                                                                        </th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        id="videoClipList"
                                                        style={{ padding: "0px" }}
                                                    >
                                                        <div
                                                            id="clipListWrap"
                                                            style={{
                                                                overflowY: "scroll",
                                                                height: "100%",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <div
                                                                id="clipContents"
                                                                style={{
                                                                    overflow:
                                                                        "hidden",
                                                                    whiteSpace:
                                                                        "nowrap",
                                                                }}
                                                            >
                                                                <PlayList
                                                                    criteria={criteria}
                                                                    playList={videoList.playList}
                                                                    videoInfos={videoList.videoInfos}
                                                                    cookie={videoList.cookie}
                                                                    useLang={props.useLang}
                                                                    selectClipEventHandler={selectClipEventHandler}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <div style={{position:"absolute", zIndex:"10"}}>
                                            {initListLoading ? <PulseLoader color="#000000" height={15} width={5} radius={2} margin={2}/> : null}
                                        </div>
                                        <div style={{position:"absolute", zIndex:"10"}}>
                                            {listLoading ? <PulseLoader color="#000000" height={15} width={5} radius={2} margin={2}/> : null}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
